// extracted by mini-css-extract-plugin
export var button = "Button-module--button--bfb84";
export var buttonText = "Button-module--button-text--2d394";